import { isFeatureEnabled } from 'owa-feature-flags';
import { getUnifiedGroupsSettingsStore } from '../UnifiedGroupsSettingsStore';
import { isConsumer } from 'owa-session-store';

export function IsShareableCRUDEnabled(): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (9,5): Type 'boolean | undefined' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        (isFeatureEnabled('grp-shareable-crud') ||
            getUnifiedGroupsSettingsStore().isSensitivityLabelsEnabled) &&
        !isConsumer()
    );
}

export function IsGroupSmtpEditEnabled(): boolean {
    return (
        isFeatureEnabled('grp-shareable-crud-smtpEdit') &&
        isFeatureEnabled('grp-cardReloadAfterEditingSmtp')
    );
}
